<template>
	<div class="plan_list">
		<div class="plan_list_header">
			<div class="item">
				<div class="value">{{dataList.length === 0 ?'-':`${bindDay}天`}}</div>
				<!-- 您已绑定医生 -->
				<div class="label">{{type === 2 ?'您已绑定医生':'您已出院'}}</div>
			</div>
			<div class="line"></div>
			<div class="item">
				<div class="value">{{(dataList.length === 0)||(0 >= nextDay) ?'-':`${nextDay}天`}}</div>
				<div class="label">距离下一次复诊</div>
			</div>
		</div>
		<base-card title="复诊计划" class="mt-28">
			<template #action>
				<div class="plan_base_card_label">定期复诊有助于随时把握病情变化，及时调整治疗方案</div>
			</template>
			<div class="plan_list_item" v-for="(item,index) in dataList" :key="index">
				<div
					class="icon"
					:class="{
					'primary_icon':item.status === 2
				}"
				>
					<van-icon name="checked" />
				</div>
				<div style="flex:1" @click="showFurtherTime(item)">
					<div class="title">
						<div>{{item.title}}</div>
						<div class="tag" v-if="!item.disabled&&item.status === 2">已复诊</div>
					</div>
					<div class="label">{{$moment(item.furtherDate).format('YYYY-MM-DD')}}</div>
				</div>
				<div v-if="showButton(item)" class="plan_button" @click="showTimeDialog(item)"> 确认复诊</div>
			</div>
			<van-empty v-if="dataList.length === 0" description="描述文字">
				<template #description>
					<div class="empty_title">暂无计划</div>
					<div class="empty_label">请完善基本信息生成复诊计划</div>
				</template>
				<div class="plan_button" @click="$router.push(`/health/base/${patientId}`)">去完善</div>
			</van-empty>
		</base-card>
		<van-dialog v-model="show" show-cancel-button :beforeClose="beforeClose" @cancel="show = false">
			<template #title>
				<div>定期复诊有助于随时把握病情变化</div>
				<div>及时调整治疗方案</div>
			</template>
			<div class="select_time">
				<div class="title">请选择复诊时间</div>
				<van-field
					readonly
					class="select_time_input"
					v-model="time"
					right-icon="arrow"
					placeholder="请选择日期"
					@click-input="selectTime"
				/>
			</div>
		</van-dialog>
		<van-popup v-model="showSelectTime" position="bottom">
			<van-datetime-picker
				v-model="currentDate"
				type="date"
				title="选择日期"
				:min-date="minDate"
				:max-date="maxDate"
				@confirm="onSelectTime"
				@cancel="showSelectTime = false"
			/>
		</van-popup>
	</div>
</template>
<script>
export default {
    name: 'planList',
    data () {
        return {
            show: false,
            selectId: '',
            showSelectTime: false,
            time: '',
            currentDate: '',
            dataList: [],
            type: '',
            bindDay: '',
            furtherType: '',
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(),
        }
    },
    computed: {
        patientId () {
            return this.$route.params.id
        },
        nextDay () {
            let str = ''
            let nowArr = this.dataList.filter(v => this.$moment().format('YYYY-MM-DD') < this.$moment(v.furtherDate).format('YYYY-MM-DD'))
            if (nowArr && nowArr.length > 0) {
                let m1 = this.$moment().format("YYYY-MM-DD 00:00:00");
                //获取需要对比的时间
                console.log(nowArr[0].furtherDate)
                let m2 = this.$moment(nowArr[0].furtherDate);
                let day = m2.diff(m1, 'day');
                str = day > 0 ? day : 0
            }
            return str
        }
    },
    created () {
        this.getDataList()
    },
    methods: {

        showTimeDialog (item) {
            this.selectId = item.id
            this.time = ''
            this.currentDate = new Date()
            this.show = true
        },
        selectTime () {
            this.showSelectTime = true
        },
        onSelectTime (val) {
            this.time = this.$moment(val).format('YYYY-MM-DD')
            this.showSelectTime = false
        },
        beforeClose (action, done) {
            if (action === 'confirm') {
                if (!this.time) {
                    this.$toast('请选择时间')
                    done(false)
                    return
                }
                this.$api.plan.update({
                    confirmDate: this.time + ' 00:00:00',
                    id: this.selectId
                }).then(({ code }) => {
                    if (!code) {
                        done()
                        this.getDataList()
                    }
                })
            } else {
                done();
            }
        },
        showFurtherTime (item) {
            if (item.status !== 2 || item.disabled) {
                return
            }
            this.$dialog.alert({
                title: item.title,
                showConfirmButton: false,
                closeOnClickOverlay: true,
                message: `<span class="dialog_time">实际复诊时间:${this.$moment(item.confirmDate).format('YYYY-MM-DD')}</span>`,
            }).then(() => {
                // on close
            });

        },
        getDataList () {
            this.$api.plan.getDataList({ patientId: this.patientId }).then(({ code, data }) => {
                if (!code && data) {
                    const { furtherType, patientFurtherConsultationList, bindDay, bindDate } = data
                    let list = patientFurtherConsultationList.map(v => ({
                        ...v,
                        title: `${furtherType === 1 ? '出院后' : ''}${v.num}个月复诊`,
                    }))
                    this.dataList = [{
                        furtherDate: bindDate,
                        disabled: true,
                        title: furtherType === 2 ? '绑定医生日期' : '出院日期',
                        status: 2,
                    }].concat(list)
                    this.type = furtherType
                    this.bindDay = bindDay
                }
            })
        },
        showButton (item) {
            let nowDate = this.$moment().format('YYYY-MM-DD')
            let itemDate = this.$moment(item.furtherDate).format('YYYY-MM-DD')
            return !item.disabled && item.status === 1 && nowDate >= itemDate
        }
    }
}
</script>
<style lang="less" scoped>
.plan_list {
	padding: 40px 32px;
	&_item {
		color: #1f2329;
		padding: 0 0 86px 46px;
		font-size: 32px;
		border-left: 1px solid #e1e1e1;
		position: relative;
		display: flex;
		align-items: center;
		.icon {
			font-size: 30px;
			width: 54px;
			height: 54px;
			background-color: #ffffff;
			position: absolute;
			left: -27px;
			top: 0;
			color: #e1e1e1;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.primary_icon {
			color: @primary;
		}
		.title {
			font-size: 32px;
			font-weight: bold;
			margin-bottom: 14px;
			vertical-align: baseline;
			display: flex;
			align-items: center;
			.tag {
				display: inline-block;
				background-color: @primary;
				border-radius: 4px;
				color: #ffffff;
				padding: 0 9px;
				font-size: 21px;
				margin-left: 12px;
				height: 36px;
				line-height: 36px;
			}
		}
		.label {
			color: #7f7f7f;
			font-size: 28px;
		}
	}

	&_header {
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #ffffff;
		border-radius: 16px;
		padding: 40px 0;
		.item {
			flex: 1;
			.value {
				font-size: 40px;
				color: #1f2329;
				margin-bottom: 12px;
			}
			.label {
				color: #8f959e;
				font-size: 24px;
			}
		}
		.line {
			background-color: #eeeeee;
			width: 1px;
			height: 64px;
		}
	}
	.plan_base_card_label {
		color: #8f959e;
		font-family: PingFang SC;
		font-size: 26px;
		font-weight: normal;
	}
	.empty_title {
		font-size: 40px;
		color: #000000;
		text-align: center;
	}
	.empty_label {
		font-size: 28px;
		color: @gray-9;
		margin-top: 12px;
		text-align: center;
	}
	.plan_button {
		max-width: 140px;
		padding: 0 40px;
		height: 60px;
		border-radius: 10px;
		font-size: 26px;
		color: @primary;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 2px solid @primary;
	}
}

.plan_list_item:last-child {
	border-left: none;
}
.select_time {
	padding: 38px 47px;
	font-size: 30px;
	color: #1f2329;
	.title {
		margin-bottom: 20px;
	}
	&_input {
		background-color: #f5f6f7;
		padding: 20px 24px;
		border-radius: 12px;
		font-size: 28px;
	}
}
</style>
<style lang="less">
.dialog_time {
	font-size: 34px;
	font-weight: bold;
	color: @primary;
	margin-top: 14px;
}
</style>